export enum ReportsManagementMutations {
    SET_AVAILABILITY_REGISTRY_DATA = 'SET_AVAILABILITY_REGISTRY_DATA',
    SET_INCIDENT_REGISTRY_VIEW = 'SET_INCIDENT_REGISTRY_VIEW',
    SET_HISTORY_REPORTS = 'SET_HISTORY_REPORTS',
    SET_HISTORY_INCIDENTS = 'SET_HISTORY_INCIDENTS',
}
